/**
 * 系统自定义配置
 */

const customization = {
  //需要在CRM中打开PORTAL页面时，才需要配置，其他情况下为空，示例：http://192.168.1.111:8080/crmdev
  crmUrl: "",
  theme: {
    direction: "top-bottom",  //left-right 或  top-bottom
  },
  //版本描述，支持HTML
  copyright: "<span>Copyright © 2017 苏州瑞泰信息技术有限公司 All Rights Reserved</span>",
};

export const copyright = customization.copyright;
export const crmUrl = customization.crmUrl;
export const theme = customization.theme;

export default customization;



// WEBPACK FOOTER //
// ./src/config/customization.js